<template>
    <div
        v-if="destinationObject && isHideObjectInfo"
        :class="['o-map-object-info-otg', 'ui', {'force': isForce} ]"
        :style="componentStyles"
    >
        <div class="map-object-info-otg-building">
            {{ buildingName }}
        </div>
        <div class="map-object-info-otg-floor">
            {{ floorName }}
        </div>
        <div class="map-object-info-otg-entrance">
            {{ entranceName }}
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'OMapObjectInfoOtg',
    computed: {
        ...mapGetters([
            't',
            't2',
            'getMapConfigProp',
            'getDenormalisedObjectById',
            'getObjectClosestEntranceId',
        ]),
        isForce(){
            return this.$route.query['ui.objectInfo'] === 'force';
        },
        destinationObjectId(){
            return Number(this.$route.query.t || this.$route.query.mTo);
        },
        destinationObject() {
            return this.getDenormalisedObjectById(this.destinationObjectId);
        },
        destinationClosetEntranceId(){
            return this.getObjectClosestEntranceId(this.destinationObjectId);
        },
        destinationClosetEntrance(){
            return this.getDenormalisedObjectById(this.destinationClosetEntranceId);
        },
        objectFloorName() {
            return this.t2(this.destinationObject, 'floor').split(',')[0];
        },
        objectFloorNameDescription() {
            return this.t2(this.destinationObject, 'floor').split(',')[1];
        },
        floorName() {
            return this.objectFloorName || this.t2(this.destinationObject.floor, 'name');
        },
        buildingName() {
            return this.t2(this.destinationObject.floor, 'building_index');
        },
        entranceName() {
            return this.objectFloorNameDescription || this.t2(this.destinationClosetEntrance, 'name');
        },
        isHideObjectInfo() {
            return !this.componentParams.hide_object_routes?.includes(this.$route.name)
        },
        hideObjectRoutes() {
            return this.componentParams.hide_object_routes || []
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OMapObjectInfoOtg.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OMapObjectInfoOtg.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OMapObjectInfoOtg.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.footer.OMapObjectInfoOtg.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
